export default "__VITE_ASSET__1fbb7c6e__"